import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AboutUsPageService } from 'src/app/core/services/about-us-page.service';
import { PermissionService } from 'src/app/core/services/permision.service';
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";

@Component({
  selector: 'app-about-about',
  templateUrl: './about-about.component.html',
  styleUrls: ['./about-about.component.scss']
})
export class AboutAboutComponent implements OnInit {

  aboutForm: FormGroup;
  hasChanges = false;
  isUpdating = false;
  isSubmitted = false;
  isNew = false;
  public Editor = ClassicEditor;

  @Input() page;

  constructor(private fb: FormBuilder, private api: AboutUsPageService,
    private toastr: ToastrService, public permission: PermissionService) { }

  ngOnInit(): void {
    this.resetForm();
    this.getData();
  }

  resetForm(data?) {
    this.aboutForm = this.fb.group({
      id: [data ? data.id : null],
      description: [data ? data.description : '', [Validators.required]],
    })
    this.onChanges();
  }

  onChanges(): void {
    this.aboutForm.valueChanges.subscribe(() => {
      Object.keys(this.aboutForm.controls).map((key) => {
        if (this.aboutForm.get(key).dirty) this.hasChanges = true;
      })
    });
  }


  onSubmit(form) {
    if (form.valid) {
      this.isUpdating = true;
      if (this.isNew) {
        this.api.postAboutData(form.value).subscribe(
          (result: any) => {
            this.resetForm(result);
            this.toastr.success("Content Updated Successfully!");
            this.hasChanges = false;
            this.isUpdating = false;
            this.isNew = false;
          },
          () => {
            this.isUpdating = false;
          }
        )
      } else {
        this.api.setAboutData(form.value.id, form.value).subscribe(
          (result: any) => {
            this.resetForm(result);
            this.toastr.success("Content Updated Successfully!");
            this.hasChanges = false;
            this.isUpdating = false;
          },
          () => {
            this.isUpdating = false;
          }
        )
      }
    } else {
      this.isSubmitted = true;
      this.toastr.warning("Fill all fields and Save");
    }
  }

  getData() {
    this.api.getAboutData().subscribe(
      (result: any) => {
        this.resetForm(result[0]);
        if (result.length == 0) this.isNew = true;
        else this.isNew = false;
      })
  }

  checkPermission(type) {
    return this.permission.hasPermission(type);
  }
}